// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e2ece616","732":"e8e0a56a","977":"3077de62"}[chunkId] + ".chunk.js";
};